import { corePhraseGroups } from './corePhrases';
import { highFrequencyVocabSets } from './highFrequencyVocab';
import { peopleAndRolesSet, problemSolvingExtraGroups } from './peopleAndRoles';
import { tensePhraseSets } from './tensePhraseSets';

const p = (english, mandarin, spoken) => ({ english, mandarin, spoken });

const group = (id, title, phrases) => ({ id, title, phrases });

export const phraseSets = [
  {
    id: 'core',
    title: 'Core Everyday Phrases',
    larpRole: 'general',
    groups: corePhraseGroups,
  },
  {
    id: 'airport',
    title: 'Airport / Travel',
    larpRole: 'airport',
    groups: [
      group('airport', 'Airport / Travel', [
        p('I’d like to check in for my flight', 'wǒ xiǎng bàn lǐ dēngjī shǒuxù', '我想办理登机手续'),
        p('Here is my passport', 'zhè shì wǒ de hùzhào', '这是我的护照'),
        p('I have my ticket', 'wǒ yǒu jīpiào', '我有机票'),
        p('I’m flying to ___ today', 'wǒ jīntiān yào qù…', '我今天要去'),
        p('What time does boarding start', 'dēngjī jǐ diǎn kāishǐ', '登机几点开始'),
        p('Which gate is my flight', 'wǒ de hángbān zài nǎ ge dēngjīkǒu', '我的航班在哪个登机口'),
        p('How many bags can I check in', 'wǒ kěyǐ tuōyùn jǐ ge xíngli', '我可以托运几个行李'),
        p('I only have one carry-on', 'wǒ zhǐ yǒu yí gè suíshēn xíngli', '我只有一个随身行李'),
        p('Is my flight on time', 'wǒ de hángbān zhǔnshí ma', '我的航班准时吗'),
        p('Can I change my seat', 'wǒ kěyǐ huàn zuòwèi ma', '我可以换座位吗'),
        p('Do I need to take off my shoes', 'wǒ yào tuō xié ma', '我要脱鞋吗'),
        p('Should I remove my laptop', 'wǒ yào náchū bǐjìběn diànnǎo ma', '我要拿出笔记本电脑吗'),
        p('Is this allowed in carry-on', 'zhè ge kěyǐ suíshēn xiédài ma', '这个可以随身携带吗'),
        p('Where is the security checkpoint', 'ānjiǎn zài nǎlǐ', '安检在哪里'),
        p('Where do I go next', 'wǒ xià yī bù qù nǎlǐ', '我下一步去哪里'),
        p('My flight was delayed', 'wǒ de hángbān wǎndiǎn le', '我的航班晚点了'),
        p('My flight was cancelled', 'wǒ de hángbān qǔxiāo le', '我的航班取消了'),
        p('Can you help me rebook', 'nǐ/nín néng bāng wǒ chóngxīn yùdìng ma', '你能帮我重新预订吗'),
        p('I missed my flight', 'wǒ cuòguòle hángbān', '我错过了航班'),
        p('My luggage is missing', 'wǒ de xíngli diū le', '我的行李丢了'),
        p('Where can I file a report', 'wǒ zài nǎlǐ kěyǐ bàogào', '我在哪里可以报告'),
        p('I need assistance', 'wǒ xūyào bāngzhù', '我需要帮助'),
        p('Can you help me find my gate', 'nǐ/nín néng bāng wǒ zhǎo dēngjīkǒu ma', '你能帮我找登机口吗'),
        p('I don’t understand this announcement', 'wǒ tīng bù dǒng zhège gǎngbào', '我听不懂这个广播'),
        p('Is there someone who speaks English', 'yǒu méiyǒu rén huì shuō Yīngyǔ', '有没有人会说英语'),
      ]),
    ],
  },
  {
    id: 'restaurant',
    title: 'Restaurant / Waiter',
    larpRole: 'restaurant',
    groups: [
      group('restaurant', 'Restaurant / Waiter', [
        p('I’d like a table for two', 'wǒ xiǎng yào liǎng rén de zhuōzi', '我想要两人桌'),
        p('Do you have a menu in English', 'yǒu Yīngyǔ càidān ma', '有英文菜单吗'),
        p('Can we sit outside', 'wǒmen kěyǐ zuò zài wàimiàn ma', '我们可以坐外面吗'),
        p('Is there a waiting list', 'yào páiduì děnghòu ma', '要排队等候吗'),
        p('How long is the wait', 'yào děng duō jiǔ', '要等多久'),
        p('What do you recommend', 'nǐ/nín tuījiàn shénme', '你推荐什么'),
        p('I’d like to order ___', 'wǒ xiǎng diǎn…', '我想点这个'),
        p('Can I have the same as this picture', 'wǒ kěyǐ yào hé zhè zhāng tú yīyàng de ma', '我可以要和这张图一样的吗'),
        p('Is this dish spicy', 'zhè dào cài là ma', '这道菜辣吗'),
        p('Can I get it without ___', 'wǒ kěyǐ bù jiā… ma', '我可以不加这个吗'),
        p('I’d like water', 'wǒ xiǎng yào shuǐ', '我想要水'),
        p('Do you have vegetarian options', 'yǒu sùshí xuǎnxiàng ma', '有素食选项吗'),
        p('Can I see the dessert menu', 'wǒ kěyǐ kàn tiánpǐn càidān ma', '我可以看甜品菜单吗'),
        p('Can I get the bill', 'wǒ kěyǐ mǎidān ma', '我可以买单吗'),
        p('What is in this dish', 'zhè dào cài lǐ yǒu shénme', '这道菜里有什么'),
        p('Can you explain this item', 'nǐ/nín néng jiěshì zhè ge ma', '你能解释这个吗'),
        p('This is not what I ordered', 'zhè bù shì wǒ diǎn de', '这不是我点的'),
        p('Can you check this again', 'nǐ/nín néng zài chá yí biàn ma', '你能再查一遍吗'),
        p('This is too salty', 'zhè tài xián le', '这太咸了'),
        p('Can I get a replacement', 'wǒ kěyǐ huàn yí fèn bié de ma', '我可以换一份别的吗'),
        p('Can I get extra napkins', 'wǒ kěyǐ duō yào jǐ zhāng cān jīn ma', '我可以多要几张餐巾吗'),
        p('Can I have more sauce', 'wǒ kěyǐ zài yào diǎn jiàngliào ma', '我可以再要点酱料吗'),
        p('Can I get this to go', 'wǒ kěyǐ dǎbāo dài zǒu ma', '我可以打包带走吗'),
        p('Do you accept card payments', 'kěyǐ shuākǎ fùkuǎn ma', '可以刷卡付款吗'),
        p('Thank you, everything was great', 'xièxie, dōu hěn hǎo', '谢谢，都很好'),
      ]),
    ],
  },
  {
    id: 'gas-station',
    title: 'Gas Station / Convenience Store',
    larpRole: 'gas-station',
    groups: [
      group('gas-station', 'Gas Station / Convenience Store', [
        p('I need to fill up my car', 'wǒ yào gěi chē jiā yóu', '我要给车加油'),
        p('Which pump should I use', 'wǒ yīnggāi yòng nǎ ge yóubèng', '我应该用哪个油泵'),
        p('I want regular gas', 'wǒ yào pǔtōng qìyóu', '我要普通汽油'),
        p('How do I pay for the gas', 'jiā yóu zěnme fùqián', '加油怎么付钱'),
        p('Can I pay at the pump', 'wǒ kěyǐ zài yóubèng shàng fùkuǎn ma', '我可以在油泵上付款吗'),
        p('I’d like to prepay for pump number ___', 'wǒ xiǎng xiān fù… hào yóubèng de qián', '我想先付这个油泵的钱'),
        p('Do you accept card payments', 'kěyǐ shuākǎ fùkuǎn ma', '可以刷卡付款吗'),
        p('Can I get a receipt', 'wǒ kěyǐ yào shōujù ma', '我可以要收据吗'),
        p('Where are the drinks', 'yǐnliào zài nǎlǐ', '饮料在哪里'),
        p('Where can I find snacks', 'língshí zài nǎlǐ', '零食在哪里'),
        p('Do you have hot coffee', 'yǒu rè kāfēi ma', '有热咖啡吗'),
        p('Is there any fresh food', 'yǒu xiān zuò de shíwù ma', '有现做的食物吗'),
        p('Where are the restrooms', 'xǐshǒujiān zài nǎlǐ', '洗手间在哪里'),
        p('Do you sell phone chargers', 'nǐmen mài shǒujī chōngdiànqì ma', '你们卖手机充电器吗'),
        p('Do you have pain medicine', 'yǒu zhǐtòng yào ma', '有止痛药吗'),
        p('Where are the cold drinks', 'lěng yǐnliào zài nǎlǐ', '冷饮料在哪里'),
        p('Do you have bottled water', 'yǒu píngzhuāng shuǐ ma', '有瓶装水吗'),
        p('Is there an ATM here', 'zhèlǐ yǒu ATM ma', '这里有ATM吗'),
        p('The pump isn’t working', 'yóubèng huài le', '油泵坏了'),
        p('My card didn’t go through', 'wǒ de kǎ méi shuā chéng', '我的卡没刷成'),
        p('Can you help me with the machine', 'nǐ/nín néng bāng wǒ yòng zhè tái jīqì ma', '你能帮我用这台机器吗'),
        p('Do you have change', 'yǒu língqián ma', '有零钱吗'),
        p('Can I return this item', 'wǒ kěyǐ tuì huí zhè ge ma', '我可以退回这个吗'),
        p('Can you check the price', 'nǐ/nín néng chá yíxià jiàgé ma', '你能查一下价格吗'),
        p('Thank you, have a good day', 'xièxie, zhù nǐ/nín yī tiān yúkuài', '谢谢，祝你一天愉快'),
      ]),
    ],
  },
  {
    id: 'shop',
    title: 'Shop / Store',
    larpRole: 'shop',
    groups: [
      group('department', 'Department Store', [
        p('Where can I find the clothing section', 'fúzhuāng qū zài nǎlǐ', '服装区在哪里'),
        p('I’m looking for men’s/women’s clothing', 'wǒ zài zhǎo nánzhuāng/nǚzhuāng', '我在找服装'),
        p('Where are the shoes', 'xiézi zài nǎlǐ', '鞋子在哪里'),
        p('Do you have this in another size', 'yǒu bié de chǐcùn ma', '有别的尺寸吗'),
        p('Where is the electronics department', 'diànzǐ chǎnpǐn qū zài nǎlǐ', '电子产品区在哪里'),
        p('I’m looking for kitchen items', 'wǒ zài zhǎo chúfáng yòngpǐn', '我在找厨房用品'),
        p('Where can I find bedding', 'chuángpǐn zài nǎlǐ', '床品在哪里'),
        p('Do you sell home decor', 'nǐmen mài jiājū zhuāngshì ma', '你们卖家居装饰吗'),
        p('Where are the toys', 'wánjù zài nǎlǐ', '玩具在哪里'),
        p('Do you have cleaning supplies', 'yǒu qīngjié yòngpǐn ma', '有清洁用品吗'),
        p('Do you have this in a different color', 'yǒu bié de yánsè ma', '有别的颜色吗'),
        p('Is this item on sale', 'zhè ge dǎzhé ma', '这个打折吗'),
        p('Can you check the price', 'nǐ/nín néng chá yíxià jiàgé ma', '你能查一下价格吗'),
        p('Do you have more of these', 'hái yǒu ma', '还有吗'),
        p('Is there a warranty', 'yǒu bǎoxiū ma', '有保修吗'),
        p('Can you explain the return policy', 'nǐ/nín néng jiěshì tuìhuò zhèngcè ma', '你能解释退货政策吗'),
        p('Does this come with accessories', 'hái yǒu pèijiàn ma', '还有配件吗'),
        p('Is this the latest model', 'zhè shì zuìxīn kuǎn ma', '这是最新款吗'),
        p('Where is the checkout', 'shōuyíntái zài nǎlǐ', '收银台在哪里'),
        p('Can I pay here', 'wǒ kěyǐ zài zhèlǐ fùkuǎn ma', '我可以在这里付款吗'),
        p('Do you accept returns', 'kěyǐ tuìhuò ma', '可以退货吗'),
        p('I’d like to return this', 'wǒ xiǎng tuì huí zhè ge', '我想退回这个'),
        p('Can I get a gift receipt', 'wǒ kěyǐ yào lǐwù shōujù ma', '我可以要礼物收据吗'),
        p('Do you offer gift wrapping', 'yǒu lǐwù bāozhuāng ma', '有礼物包装吗'),
        p('Thank you, that’s all', 'xièxie, jiù zhème duō', '谢谢，就这么多'),
      ]),
      group('grocery', 'Grocery Store / Supermarket', [
        p('Where can I find the bread', 'miànbāo zài nǎlǐ', '面包在哪里'),
        p('Where is the produce section', 'shūcài shuǐguǒ qū zài nǎlǐ', '蔬菜水果区在哪里'),
        p('Do you have fresh fruit', 'yǒu xīnxiān shuǐguǒ ma', '有新鲜水果吗'),
        p('Where are the eggs', 'jīdàn zài nǎlǐ', '鸡蛋在哪里'),
        p('Where is the meat section', 'ròu lèi qū zài nǎlǐ', '肉类区在哪里'),
        p('Do you sell spices', 'nǐmen mài tiáoliào ma', '你们卖调料吗'),
        p('Where are the frozen foods', 'lěngdòng shípǐn zài nǎlǐ', '冷冻食品在哪里'),
        p('Do you have organic options', 'yǒu yǒujī shípǐn ma', '有有机食品吗'),
        p('Is this fresh', 'zhè xīnxiān ma', '这新鲜吗'),
        p('When was this made', 'zhè shì shénme shíhou zuò de', '这是什么时候做的'),
        p('Is this gluten-free', 'zhè shì wú gǔwù zhì de ma', '这是无谷物的吗'),
        p('Do you have a smaller size', 'yǒu xiǎo yì diǎn de ma', '有小一点的吗'),
        p('Do you have a larger size', 'yǒu dà yì diǎn de ma', '有大一点的吗'),
        p('Is this on sale', 'zhè dǎzhé ma', '这打折吗'),
        p('Can you check the price', 'nǐ/nín néng chá yíxià jiàgé ma', '你能查一下价格吗'),
        p('Do you have bags', 'yǒu dàizi ma', '有袋子吗'),
        p('Can I pay with card', 'wǒ kěyǐ shuākǎ ma', '我可以刷卡吗'),
        p('Do you accept digital payments', 'kěyǐ shùzì fùkuǎn ma', '可以数字付款吗'),
        p('Can I return this', 'wǒ kěyǐ tuì huí zhè ge ma', '我可以退回这个吗'),
        p('Can you help me find this item', 'nǐ/nín néng bāng wǒ zhǎo zhè ge ma', '你能帮我找这个吗'),
        p('This item scanned wrong', 'zhè ge sǎo cuò le', '这个扫错了'),
        p('I think the price is different', 'wǒ juéde jiàgé bù yíyàng', '我觉得价格不一样'),
        p('My card didn’t work', 'wǒ de kǎ méi yòng', '我的卡没用'),
        p('Can you call a manager', 'nǐ/nín néng jiào jīnglǐ ma', '你能叫经理吗'),
        p('Thank you for your help', 'xièxie nǐ/nín de bāngzhù', '谢谢你的帮助'),
      ]),
    ],
  },
  {
    id: 'hotel',
    title: 'Hotel Navigation',
    larpRole: 'hotel',
    groups: [
      group('hotel', 'Hotel Navigation', [
        p('I have a reservation', 'wǒ yǒu yùdìng', '我有预订'),
        p('I’d like to check in', 'wǒ xiǎng bàn lǐ rùzhù', '我想办理入住'),
        p('What time is check-in', 'jǐ diǎn kěyǐ rùzhù', '几点可以入住'),
        p('What time is check-out', 'jǐ diǎn yào tuìfáng', '几点要退房'),
        p('Can I get a room on a higher floor', 'wǒ kěyǐ yào gāo lóu de fángjiān ma', '我可以要高楼的房间吗'),
        p('Do you have any rooms available', 'hái yǒu kōng fáng ma', '还有空房吗'),
        p('Is breakfast included', 'hán zǎocān ma', '含早餐吗'),
        p('Can I see the room first', 'wǒ kěyǐ xiān kàn fángjiān ma', '我可以先看房间吗'),
        p('I’d like to extend my stay', 'wǒ xiǎng yáncháng zhù sù', '我想延长住宿'),
        p('Can I get a late check-out', 'wǒ kěyǐ wǎn yīdiǎn tuìfáng ma', '我可以晚一点退房吗'),
        p('Can I get extra towels', 'wǒ kěyǐ duō yào jǐ tiáo máojīn ma', '我可以多要几条毛巾吗'),
        p('Can you clean my room', 'nǐ/nín néng dǎsǎo wǒ de fángjiān ma', '你能打扫我的房间吗'),
        p('Is room service available', 'yǒu kèfáng fúwù ma', '有客房服务吗'),
        p('Can I get more toiletries', 'wǒ kěyǐ zài yào yìxiē xǐshù yòngpǐn ma', '我可以再要一些洗漱用品吗'),
        p('The air conditioner isn’t working', 'kōngtiáo huài le', '空调坏了'),
        p('The Wi-Fi isn’t working', 'Wi-Fi bù hǎo yòng', '无线网络不好用'),
        p('Can you fix this', 'nǐ/nín néng xiū hǎo ma', '你能修好吗'),
        p('Can I change rooms', 'wǒ kěyǐ huàn fángjiān ma', '我可以换房间吗'),
        p('Where is the elevator', 'diàntī zài nǎlǐ', '电梯在哪里'),
        p('How do I get to the gym', 'qù jiànshēnfáng zěnme zǒu', '去健身房怎么走'),
        p('Where do I pay', 'zài nǎlǐ fùkuǎn', '在哪里付款'),
        p('Can I pay with card', 'wǒ kěyǐ shuākǎ ma', '我可以刷卡吗'),
        p('Can you call a taxi', 'nǐ/nín néng jiào chūzūchē ma', '你能叫出租车吗'),
        p('Is there a place to store my luggage', 'yǒu jìcún xíngli de dìfang ma', '有寄存行李的地方吗'),
        p('Thank you for your help', 'xièxie nǐ/nín de bāngzhù', '谢谢你的帮助'),
      ]),
    ],
  },
  {
    id: 'transportation',
    title: 'Transportation & Directions',
    groups: [
      group('transportation', 'Transportation & Directions', [
        p('Where is the bus stop', 'gōngjiāo zhàn zài nǎlǐ', '公交站在哪里'),
        p('How do I get to ___', 'wǒ zěnme qù…', '我怎么去那里'),
        p('Is this the right way', 'zhè shì duì de lù ma', '这是对的路线吗'),
        p('How far is it', 'yǒu duō yuǎn', '有多远'),
        p('Can you show me on the map', 'nǐ/nín néng zài dìtú shàng zhǐ gěi wǒ kàn ma', '你能在地图上指给我看吗'),
        p('Is it walking distance', 'zǒu lù néng dào ma', '走路能到吗'),
        p('Which road should I take', 'wǒ yīnggāi zǒu nǎ tiáo lù', '我应该走哪条路'),
        p('Is there a shortcut', 'yǒu jìnjìng ma', '有捷径吗'),
        p('Where does this bus go', 'zhè liàng gōngjiāo qù nǎlǐ', '这辆公交去哪里'),
        p('Does this train stop at ___', 'zhè liàng huǒchē zài… tíng ma', '这辆火车在那里停吗'),
        p('How much is the ticket', 'piào duōshao qián', '票多少钱'),
        p('Where can I buy a ticket', 'wǒ zài nǎlǐ kěyǐ mǎi piào', '我在哪里可以买票'),
        p('What time does the bus arrive', 'gōngjiāo jǐ diǎn dào', '公交几点到'),
        p('Is this seat taken', 'zhè ge zuòwèi yǒu rén ma', '这个座位有人吗'),
        p('How long is the ride', 'yào zuò duō jiǔ', '要坐多久'),
        p('Can you take me to ___', 'nǐ/nín néng sòng wǒ qù… ma', '你能送我去那里吗'),
        p('Can you stop here', 'nǐ/nín néng zài zhèlǐ tíng ma', '你能在这里停吗'),
        p('Can you wait for me', 'nǐ/nín néng děng wǒ ma', '你能等我吗'),
        p('How much is the fare', 'piào jià duōshao', '票价多少'),
        p('Do you accept card', 'kěyǐ shuākǎ ma', '可以刷卡吗'),
        p('I think I’m lost', 'wǒ juéde wǒ mílù le', '我觉得迷路了'),
        p('I missed my stop', 'wǒ cuòguò zhàn le', '我错过站了'),
        p('Is this the correct platform', 'zhè shì duì de yuètái ma', '这是对的站台吗'),
        p('I need help finding this place', 'wǒ xūyào bāngzhù zhǎo zhè ge dìfang', '我需要帮助找这个地方'),
        p('Can you point me in the right direction', 'nǐ/nín néng gàosu wǒ fāngxiàng ma', '你能告诉我方向吗'),
      ]),
    ],
  },
  {
    id: 'medical',
    title: 'Medical / Pharmacy / Emergencies',
    groups: [
      group('medical', 'Medical / Pharmacy / Emergencies', [
        p('I don’t feel well', 'wǒ gǎnjué bù shūfu', '我感觉不舒服'),
        p('I have pain here', 'wǒ zhèlǐ téng', '我这里疼'),
        p('I feel dizzy', 'wǒ tóu yūn', '我头晕'),
        p('I have a fever', 'wǒ fāshāo le', '我发烧了'),
        p('I have a headache', 'wǒ tóutòng', '我头痛'),
        p('I’m having trouble breathing', 'wǒ hūxī kùnnan', '我呼吸困难'),
        p('I feel sick', 'wǒ gǎnjué bù shūfu', '我感觉不舒服'),
        p('Do you have medicine for colds', 'yǒu gǎnmào yào ma', '有感冒药吗'),
        p('I need something for pain', 'wǒ xūyào zhǐtòng yào', '我需要止痛药'),
        p('Is this safe to take', 'chī zhè ge ānquán ma', '吃这个安全吗'),
        p('How often should I take this', 'wǒ yīnggāi duō jiǔ chī yí cì', '我应该多久吃一次'),
        p('Are there side effects', 'yǒu fùzuòyòng ma', '有副作用吗'),
        p('Do you have bandages', 'yǒu bāngdài ma', '有绷带吗'),
        p('Do you have allergy medicine', 'yǒu guòmǐn yào ma', '有过敏药吗'),
        p('I need a doctor', 'wǒ xūyào yīshēng', '我需要医生'),
        p('I need help right now', 'wǒ xiànzài xūyào bāngzhù', '我现在需要帮助'),
        p('Call an ambulance', 'qǐng jiào jiùhùchē', '请叫救护车'),
        p('I think something is wrong', 'wǒ juéde yǒu wèntí', '我觉得有问题'),
        p('I need urgent care', 'wǒ xūyào jízhěn', '我需要急诊'),
        p('Where is the nearest hospital', 'zuìjìn de yīyuàn zài nǎlǐ', '最近的医院在哪里'),
        p('Where is the pharmacy', 'yàodiàn zài nǎlǐ', '药店在哪里'),
        p('Can you help me', 'nǐ/nín néng bāng wǒ ma', '你能帮我吗'),
        p('I need water', 'wǒ xūyào shuǐ', '我需要水'),
        p('I need to sit down', 'wǒ xūyào zuò yíxià', '我需要坐一下'),
        p('Thank you for helping me', 'xièxie nǐ/nín bāng wǒ', '谢谢你帮我'),
      ]),
    ],
  },
  {
    id: 'workplace',
    title: 'Workplace Basics',
    groups: [
      group('workplace', 'Workplace Basics', [
        p('Can you explain this task', 'nǐ/nín néng jiěshì zhè ge gōngzuò ma', '你能解释这个工作吗'),
        p('What should I do first', 'wǒ yīnggāi xiān zuò shénme', '我应该先做什么'),
        p('I need more information', 'wǒ xūyào gèng duō xìnxī', '我需要更多信息'),
        p('Is this correct', 'zhè duì ma', '这对吗'),
        p('Can you check this', 'nǐ/nín néng chá yíxià ma', '你能查一下吗'),
        p('How do I do this', 'wǒ zěnme zuò', '我怎么做'),
        p('I’m still working on it', 'wǒ hái zài zuò', '我还在做'),
        p('I will finish it today', 'wǒ jīntiān huì wánchéng', '我今天会完成'),
        p('Let’s schedule a meeting', 'wǒmen ānpái yí gè huìyì ba', '我们安排一个会议吧'),
        p('When is the deadline', 'jiézhǐ shíjiān shì shénme shíhou', '截止时间是什么时候'),
        p('Can we talk later', 'wǒmen kěyǐ shāohòu liáo ma', '我们可以稍后再聊吗'),
        p('I’m available now', 'wǒ xiànzài yǒu kòng', '我现在有空'),
        p('I’m not available right now', 'wǒ xiànzài méi kòng', '我现在没空'),
        p('Can we review this together', 'wǒmen kěyǐ yìqǐ kàn zhè ge ma', '我们可以一起看这个吗'),
        p('I need more time', 'wǒ xūyào gèng duō shíjiān', '我需要更多时间'),
        p('Can you help me with this', 'nǐ/nín néng bāng wǒ zuò zhè ge ma', '你能帮我做这个吗'),
        p('Let’s work on this together', 'wǒmen yìqǐ zuò ba', '我们一起做吧'),
        p('I agree with your idea', 'wǒ tóngyì nǐ/nín de xiǎngfǎ', '我同意你的想法'),
        p('I have a suggestion', 'wǒ yǒu yí gè jiànyì', '我有一个建议'),
        p('That’s a good point', 'shuō de hěn hǎo', '说得很好'),
        p('Something isn’t working', 'yǒu dōngxi bù hǎo yòng', '有东西不好用'),
        p('I’m having trouble with this', 'wǒ zuò zhè ge yǒu kùnnan', '我做这个有困难'),
        p('I need support', 'wǒ xūyào zhīchí', '我需要支持'),
        p('I don’t understand this part', 'wǒ bù dǒng zhè yī bùfen', '我不懂这一部分'),
        p('Let’s fix this issue', 'wǒmen bǎ zhè ge wèntí jiějué ba', '我们把这个问题解决吧'),
      ]),
    ],
  },
  {
    id: 'banking',
    title: 'Banking & Money',
    groups: [
      group('banking', 'Banking & Money', [
        p('I want to open an account', 'wǒ xiǎng kāi zhànghù', '我想开账户'),
        p('I want to close my account', 'wǒ xiǎng guān zhànghù', '我想关账户'),
        p('I want to deposit money', 'wǒ xiǎng cún qián', '我想存钱'),
        p('I want to withdraw cash', 'wǒ xiǎng qǔ xiànjīn', '我想取现金'),
        p('I want to transfer money', 'wǒ xiǎng zhuǎnzhàng', '我想转账'),
        p('What is the fee for this', 'zhè ge shōufèi duōshao', '这个收费多少'),
        p('Is there a minimum balance', 'yǒu zuìdī yúé yāoqiú ma', '有最低余额要求吗'),
        p('How long does the transfer take', 'zhuǎnzhàng yào duō jiǔ', '转账要多久'),
        p('Can you check my balance', 'nǐ/nín néng chá wǒ de yúé ma', '你能查我的余额吗'),
        p('Can you print my statement', 'nǐ/nín néng dǎyìn wǒ de zhàngdān ma', '你能打印我的账单吗'),
        p('My card isn’t working', 'wǒ de kǎ bù hǎo yòng', '我的卡不好用'),
        p('I lost my card', 'wǒ diū le kǎ', '我丢了卡'),
        p('I need a new card', 'wǒ xūyào xīn kǎ', '我需要新卡'),
        p('Can you block my card', 'nǐ/nín néng dòngjié wǒ de kǎ ma', '你能冻结我的卡吗'),
        p('Can you activate my card', 'nǐ/nín néng jīhuó wǒ de kǎ ma', '你能激活我的卡吗'),
        p('The ATM isn’t working', 'ATM bù hǎo yòng', 'ATM不好用'),
        p('The ATM kept my card', 'ATM tūn le wǒ de kǎ', 'ATM吞了我的卡'),
        p('I didn’t get my money', 'wǒ méi ná dào qián', '我没拿到钱'),
        p('Can you help me with the ATM', 'nǐ/nín néng bāng wǒ yòng ATM ma', '你能帮我用ATM吗'),
        p('Where is the nearest ATM', 'zuìjìn de ATM zài nǎlǐ', '最近的ATM在哪里'),
        p('Do you accept card', 'kěyǐ shuākǎ ma', '可以刷卡吗'),
        p('Do you accept digital payments', 'kěyǐ shùzì fùkuǎn ma', '可以数字付款吗'),
        p('Can I pay later', 'wǒ kěyǐ shāohòu fù ma', '我可以稍后付吗'),
        p('Can I get a receipt', 'wǒ kěyǐ yào shōujù ma', '我可以要收据吗'),
        p('Thank you for your help', 'xièxie nǐ/nín de bāngzhù', '谢谢你的帮助'),
      ]),
    ],
  },
  {
    id: 'post',
    title: 'Post Office / Delivery / Packages',
    groups: [
      group('post', 'Post Office / Delivery / Packages', [
        p('I want to send this package', 'wǒ xiǎng jì zhè ge bāoguǒ', '我想寄这个包裹'),
        p('How much is shipping', 'yùnfèi duōshao', '运费多少'),
        p('How long will it take', 'yào duō jiǔ', '要多久'),
        p('Is there tracking', 'yǒu kuàidì gēnzōng ma', '有快递跟踪吗'),
        p('I need a box', 'wǒ xūyào yí gè hézi', '我需要一个盒子'),
        p('Where is my delivery', 'wǒ de kuàidì zài nǎlǐ', '我的快递在哪里'),
        p('Can I track this', 'wǒ kěyǐ chá kuàidì ma', '我可以查快递吗'),
        p('My package is missing', 'wǒ de bāoguǒ diū le', '我的包裹丢了'),
        p('My package is damaged', 'wǒ de bāoguǒ huài le', '我的包裹坏了'),
        p('Can you check the status', 'nǐ/nín néng chá zhuàngtài ma', '你能查状态吗'),
        p('Do you have express shipping', 'yǒu kuàidì ma', '有快递吗'),
        p('Do you have international shipping', 'yǒu guójì jì sòng ma', '有国际寄送吗'),
        p('Can I return this item', 'wǒ kěyǐ tuì huí zhè ge ma', '我可以退回这个吗'),
        p('I need stamps', 'wǒ xūyào yóupiào', '我需要邮票'),
        p('I need envelopes', 'wǒ xūyào xìnfēng', '我需要信封'),
        p('I think there is a mistake', 'wǒ juéde yǒu cuò', '我觉得有错'),
        p('This address is wrong', 'zhè ge dìzhǐ cuò le', '这个地址错了'),
        p('I didn’t receive anything', 'wǒ shénme yě méi shōudào', '我什么也没收到'),
        p('Can you resend it', 'nǐ/nín néng zài fā yí cì ma', '你能再发一次吗'),
        p('Can you help me fix this', 'nǐ/nín néng bāng wǒ jiějué ma', '你能帮我解决吗'),
        p('Where is the post office', 'yóujú zài nǎlǐ', '邮局在哪里'),
        p('Where do I drop this off', 'wǒ zài nǎlǐ jì chū', '我在哪里寄出'),
        p('Can you weigh this', 'nǐ/nín néng chēng yíxià ma', '你能称一下吗'),
        p('Can you seal this', 'nǐ/nín néng bāng wǒ fēng hǎo ma', '你能帮我封好吗'),
        p('Thank you for your help', 'xièxie nǐ/nín de bāngzhù', '谢谢你的帮助'),
      ]),
    ],
  },
  {
    id: 'household',
    title: 'Household & Daily Life',
    groups: [
      group('household', 'Household & Daily Life', [
        p('The light isn’t working', 'dēng bù liàng', '灯不亮'),
        p('The water isn’t running', 'méi shuǐ', '没水'),
        p('The power went out', 'tíng diàn le', '停电了'),
        p('Something is leaking', 'yǒu dōngxi lòu shuǐ', '有东西漏水'),
        p('The door won’t open', 'mén dǎ bù kāi', '门打不开'),
        p('Can you fix this', 'nǐ/nín néng xiū hǎo ma', '你能修好吗'),
        p('Can you check this', 'nǐ/nín néng chá yíxià ma', '你能查一下吗'),
        p('I need cleaning supplies', 'wǒ xūyào qīngjié yòngpǐn', '我需要清洁用品'),
        p('I need tools', 'wǒ xūyào gōngjù', '我需要工具'),
        p('I need help with this', 'wǒ xūyào bāngzhù zuò zhè ge', '我需要帮助做这个'),
        p('I need to clean the room', 'wǒ xūyào dǎsǎo fángjiān', '我需要打扫房间'),
        p('I need to cook', 'wǒ xūyào zuò fàn', '我需要做饭'),
        p('I need to wash clothes', 'wǒ xūyào xǐ yīfu', '我需要洗衣服'),
        p('I need to throw this away', 'wǒ xūyào diū diào zhè ge', '我需要丢掉这个'),
        p('I need to organize this', 'wǒ xūyào shōushi zhè ge', '我需要收拾这个'),
        p('How do I use this machine', 'wǒ zěnme yòng zhè tái jīqì', '我怎么用这台机器'),
        p('Where is the trash bin', 'lājītǒng zài nǎlǐ', '垃圾桶在哪里'),
        p('Where is the laundry room', 'xǐ yīfáng zài nǎlǐ', '洗衣房在哪里'),
        p('Where is the fuse box', 'diànxiāng zài nǎlǐ', '电箱在哪里'),
        p('Where can I buy supplies', 'wǒ zài nǎlǐ kěyǐ mǎi yòngpǐn', '我在哪里可以买用品'),
        p('Can you help me move this', 'nǐ/nín néng bāng wǒ bān zhè ge ma', '你能帮我搬这个吗'),
        p('Can you show me how', 'nǐ/nín néng jiāo wǒ zěnme zuò ma', '你能教我怎么吗'),
        p('Can you fix the internet', 'nǐ/nín néng xiū hǎo wǎngluò ma', '你能修好网络吗'),
        p('Can you check the heater', 'nǐ/nín néng chá yíxià nuǎnqì ma', '你能查一下暖气吗'),
        p('Thank you for your help', 'xièxie nǐ/nín de bāngzhù', '谢谢你的帮助'),
      ]),
    ],
  },
  {
    id: 'social',
    title: 'Social & Small Talk',
    groups: [
      group('social', 'Social & Small Talk', [
        p('How was your day', 'nǐ/nín jīntiān zěnmeyàng', '你今天怎么样'),
        p('What are you doing', 'nǐ/nín zài zuò shénme', '你在做什么'),
        p('That sounds fun', 'tīng qǐlái hěn yǒuyìsi', '听起来很有意思'),
        p('That’s interesting', 'zhēn yǒu yìsi', '真有意思'),
        p('I like that', 'wǒ xǐhuan', '我喜欢'),
        p('What do you think', 'nǐ/nín zěnme kàn', '你怎么看'),
        p('I agree', 'wǒ tóngyì', '我同意'),
        p('I disagree', 'wǒ bù tóngyì', '我不同意'),
        p('I’m not sure', 'wǒ bù quèdìng', '我不确定'),
        p('That makes sense', 'hěn yǒu dàolǐ', '很有道理'),
        p('I’m happy today', 'wǒ jīntiān hěn gāoxìng', '我今天很高兴'),
        p('I’m tired today', 'wǒ jīntiān hěn lèi', '我今天很累'),
        p('I’m stressed', 'wǒ yǒu yālì', '我有压力'),
        p('I’m excited', 'wǒ hěn xīngfèn', '我很兴奋'),
        p('I’m bored', 'wǒ hěn wúliáo', '我很无聊'),
        p('Where do you live', 'nǐ/nín zhù zài nǎlǐ', '你住在哪里'),
        p('What do you like to do', 'nǐ/nín xǐhuan zuò shénme', '你喜欢做什么'),
        p('What are your hobbies', 'nǐ/nín de àihào shì shénme', '你的爱好是什么'),
        p('Tell me more', 'duō shuō yì diǎn', '多说一点'),
        p('I understand', 'wǒ míngbai le', '我明白了'),
        p('Let’s talk later', 'wǒmen shāohòu liáo', '我们稍后再聊'),
        p('I have to go now', 'wǒ xiànzài děi zǒu le', '我现在得走了'),
        p('It was nice talking', 'hěn gāoxìng gēn nǐ/nín liáo', '很高兴跟你聊'),
        p('See you soon', 'hěn kuài jiàn', '很快见'),
        p('Take care', 'bǎozhòng', '保重'),
      ]),
    ],
  },
  {
    id: 'problem',
    title: 'Problem-Solving / Clarification',
    groups: [
      group('problem', 'Problem-Solving / Clarification', [
        p('I didn’t understand', 'wǒ méi tīng dǒng', '我没听懂'),
        p('Can you repeat that', 'nǐ/nín néng zài shuō yí biàn ma', '你能再说一遍吗'),
        p('Can you say it slowly', 'nǐ/nín néng shuō màn yì diǎn ma', '你能说慢一点吗'),
        p('What do you mean', 'nǐ/nín shì shénme yìsi', '你是什么意思'),
        p('Can you explain this', 'nǐ/nín néng jiěshì ma', '你能解释吗'),
        p('Something is wrong', 'yǒu wèntí', '有问题'),
        p('This doesn’t work', 'zhè bù hǎo yòng', '这不好用'),
        p('I think there is a mistake', 'wǒ juéde yǒu cuò', '我觉得有错'),
        p('I’m confused', 'wǒ hěn kùnhuò', '我很困惑'),
        p('I need help', 'wǒ xūyào bāngzhù', '我需要帮助'),
        p('What should I do', 'wǒ yīnggāi zěnme zuò', '我应该怎么做'),
        p('How can I fix this', 'wǒ zěnme xiū hǎo', '我怎么修好'),
        p('Can we try again', 'wǒmen kěyǐ zài shì yí cì ma', '我们可以再试一次吗'),
        p('Let’s check this', 'wǒmen chá yíxià ba', '我们查一下吧'),
        p('Let’s start over', 'wǒmen chónglái ba', '我们重来吧'),
        p('Can you show me', 'nǐ/nín néng gěi wǒ kàn ma', '你能给我看吗'),
        p('Can you help me', 'nǐ/nín néng bāng wǒ ma', '你能帮我吗'),
        p('Can you guide me', 'nǐ/nín néng zhǐdǎo wǒ ma', '你能指导我吗'),
        p('Can you check this', 'nǐ/nín néng chá yíxià ma', '你能查一下吗'),
        p('Can you correct this', 'nǐ/nín néng gǎi hǎo ma', '你能改好吗'),
        p('I understand now', 'wǒ xiànzài míngbai le', '我现在明白了'),
        p('That helps', 'hěn yǒu bāngzhù', '很有帮助'),
        p('That’s clear', 'hěn qīngchu', '很清楚'),
        p('Let’s continue', 'wǒmen jìxù ba', '我们继续吧'),
        p('Thank you for explaining', 'xièxie nǐ/nín jiěshì', '谢谢你解释'),
      ]),
      ...problemSolvingExtraGroups,
    ],
  },
  peopleAndRolesSet,
  {
    id: 'vocabulary',
    title: 'High-Frequency Vocabulary Pack',
    groups: [
      group('verbs', 'Verbs', [
        p('go', 'qù', '去'),
        p('come', 'lái', '来'),
        p('make', 'zuò', '做'),
        p('take', 'ná', '拿'),
        p('give', 'gěi', '给'),
        p('get', 'dédào', '得到'),
        p('put', 'fàng', '放'),
        p('bring', 'dài lái', '带来'),
        p('find', 'zhǎo', '找'),
        p('keep', 'bǎochí', '保持'),
        p('leave', 'líkāi', '离开'),
        p('start', 'kāishǐ', '开始'),
        p('stop', 'tíng', '停'),
        p('try', 'shì', '试'),
        p('use', 'yòng', '用'),
        p('need', 'xūyào', '需要'),
        p('want', 'xiǎng yào', '想要'),
        p('help', 'bāngzhù', '帮助'),
        p('ask', 'wèn', '问'),
        p('tell', 'gàosu', '告诉'),
        p('show', 'gěi… kàn', '给看'),
        p('call', 'dǎ diànhuà', '打电话'),
        p('work', 'gōngzuò', '工作'),
        p('move', 'yídòng', '移动'),
        p('open', 'dǎkāi', '打开'),
        p('close', 'guān', '关'),
        p('wait', 'děng', '等'),
        p('follow', 'gēn', '跟'),
        p('check', 'jiǎnchá', '检查'),
        p('change', 'gǎibiàn', '改变'),
      ]),
      group('connectors', 'Connectors', [
        p('because', 'yīnwei', '因为'),
        p('but', 'dànshì', '但是'),
        p('and', 'hé', '和'),
        p('or', 'huòzhě', '或者'),
        p('so', 'suǒyǐ', '所以'),
        p('then', 'ránhòu', '然后'),
        p('after', 'yǐhòu', '以后'),
        p('before', 'yǐqián', '以前'),
        p('while', 'de shíhou', '的时候'),
        p('when', 'dāng… shí', '当…时'),
        p('if', 'rúguǒ', '如果'),
        p('even', 'shènzhì', '甚至'),
        p('also', 'yě', '也'),
        p('only', 'zhǐ', '只'),
        p('still', 'hái', '还'),
        p('already', 'yǐjīng', '已经'),
        p('maybe', 'kěnéng', '可能'),
        p('almost', 'jīhū', '几乎'),
        p('really', 'zhēn de', '真的'),
        p('finally', 'zuìhòu', '最后'),
      ]),
      group('time-words', 'Time Words', [
        p('today', 'jīntiān', '今天'),
        p('tomorrow', 'míngtiān', '明天'),
        p('yesterday', 'zuótiān', '昨天'),
        p('now', 'xiànzài', '现在'),
        p('later', 'guò huìr', '过会儿'),
        p('soon', 'bùjiǔ', '不久'),
        p('early', 'zǎo', '早'),
        p('late', 'wǎn', '晚'),
        p('morning', 'zǎoshang', '早上'),
        p('afternoon', 'xiàwǔ', '下午'),
        p('evening', 'wǎnshang', '晚上'),
        p('night', 'yèwǎn', '夜晚'),
        p('week', 'xīngqī', '星期'),
        p('month', 'yuè', '月'),
        p('year', 'nián', '年'),
      ]),
    ],
  },
  ...highFrequencyVocabSets,
  ...tensePhraseSets,
];

export const phraseSetForRole = (role) =>
  phraseSets.find((set) => set.larpRole === role) || phraseSets[0];
